import config from "config";
import { ContentLayoutType1 } from "pages/Product/ContentLayouts/ContentLayoutType1";
import {
  AssetArea,
  DescriptionArea,
  SectionDescription,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
  Video,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";

export function Roadmap() {
  return (
    <FeatureSectionWrapper id="milestone-and-progress">
      <ContentLayoutType1>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Milestone and progress?</SectionTitle>
        </TitleArea>
        <DescriptionArea>
          <SectionDescription>
            You can check the whole milestones with the roadmap view and the
            status of work with the kanban view. The deadlines or due dates will
            be bound to the contract.
          </SectionDescription>
        </DescriptionArea>
        <AssetArea>
          <Video
            src={`${config.RESOURCE_ORIGIN}/videos/landing/product/feature-roadmap.mp4`}
            autoPlay
            muted
            loop
            playsInline
          />
        </AssetArea>
      </ContentLayoutType1>
    </FeatureSectionWrapper>
  );
}
